import { NavItem, VehicleModel } from "@/types";

// Site Configuration (Static - doesn't need translation)
export const SITE_CONFIG = {
  name: "長安跨越",
  description: "Specialized in micro electric vans, providing green mobility solutions for urban logistics and small businesses",
  url: "https://KYC-ev.com",
  ogImage: "/og-image.jpg",
  links: {
    phone: "+852 9323 9473",
    email: "Patrickhung@telemediapacific.com",
    address: "Unit K1,22/F,MG Tower, 133 Hoi Bun Road，Kwun Tong, Hong Kong",
  },
};

// Navigation Menu - Will be translated in components
export const NAV_ITEMS: NavItem[] = [
  { label: "Home", href: "/" },
  { label: "Vehicles", href: "/products" },
  { label: "About", href: "/about" },
  { label: "Contact", href: "/contact" },
];

// Vehicle Models - Features and taglines will be translated in components
export const VEHICLE_MODELS: VehicleModel[] = [
  {
    id: "1",
    name: "長安跨越 V7-EV",
    slug: "v7-ev",
    tagline: "The Ideal Choice for Smart Urban Logistics",
    price: 88000,
    image: "/img/车辆正面-白色.png",
    thumbnail: "/img/车辆侧面灰色-充电场景.png",
    specs: {
      range: 350,
      seats: 2,
      cargo: 6.7,
      maxSpeed: 120,
      chargingTime: 8,
      power: 75,
    },
    features: [
      "Class-leading cargo space",
      "Intelligent driving assistance (ACC/LCC)",
      "OTA online upgrades",
      "No B-pillar design with extra-large side opening",
      "Modular customization platform",
      "Fast charging technology",
    ],
    colors: [
      { name: "Pearl White", hex: "#FFFFFF" },
      { name: "Business Gray", hex: "#808080" },
      { name: "Sky Blue", hex: "#4A90E2" },
    ],
  },
  {
    id: "2",
    name: "長安跨越 V7-EV Long Wheelbase",
    slug: "v7-ev-long",
    tagline: "Ultra-large Space, First Choice for Commercial Transport",
    price: 98000,
    image: "/img/车辆侧面灰色-长轴距版.png",
    thumbnail: "/img/车辆侧面灰色-长轴距版.png",
    specs: {
      range: 350,
      seats: 3,
      cargo: 10.9,
      maxSpeed: 120,
      chargingTime: 7,
      power: 75,
    },
    features: [
      "Extended wheelbase 3850mm",
      "Cargo volume up to 10.9m³",
      "Multiple battery configurations",
      "Intelligent temperature control",
      "Remote vehicle monitoring",
      "Full safety features",
    ],
    colors: [
      { name: "Business Gray", hex: "#808080" },
      { name: "Midnight Black", hex: "#1a1a1a" },
      { name: "Pearl White", hex: "#FFFFFF" },
    ],
  },
];

// Company Features - Will be translated in components
export const COMPANY_FEATURES = [
  {
    icon: "Zap",
    title: "Green & Eco-friendly",
    description: "Zero emissions, contributing to urban carbon reduction",
  },
  {
    icon: "DollarSign",
    title: "Cost Effective",
    description: "Low operating costs, high value for money",
  },
  {
    icon: "Shield",
    title: "Safe & Reliable",
    description: "Multiple safety protections, drive with confidence",
  },
  {
    icon: "Settings",
    title: "Smart Technology",
    description: "IoV technology, intelligent mobility",
  },
];
